import { NotifyService } from '@/util/AppNotifyService'
import { ToastMessageOptions } from '@/types/notify'

type TNotifyService = {
  add(message: ToastMessageOptions): void;
  removeGroup(group: string): void;
  removeAllGroups(): void;
}

const $notify: TNotifyService = NotifyService

export default $notify
